import { useState } from 'react';
import { Modal, Button, Typography } from 'antd';
import { LabInvestigationComponent } from '../../pages/LaboratoryInvestigation';
import FeatherIcon from 'feather-icons-react';
const { Title } = Typography;

const LaboratoryInvestigations = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setValues,
  IsFilledForm,
  ConsultationMasterData,
  notes,
  setNotes,
}) => {
  const [modal, SetModal] = useState(false);

  return (
    <>
      {/* Laboratory Examination / Findings */}
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-3">
              <div className="mb-3">
                <h4 style={{ color: '#111827', fontWeight: '700', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <FeatherIcon icon="file-text" size="20" style={{ color: '#4f46e5' }} />
                  Laboratory Investigations
                </h4>
              </div>
              <div className="col">
                <div className="form-group">
                  <label
                    className="col-form-label"
                    style={{
                      color: errors.doctorNote && touched.doctorNote && 'red',
                    }}
                  ></label>
                  <Button className="form-control" onClick={() => SetModal(true)}>
                    Laboratory Investigations
                  </Button>
                </div>
              </div>

              {/* Display Selected Laboratory Options */}
              {values.laboratory && values.laboratory.length > 0 && (
                <div className="col mt-3">
                  <div
                    style={{
                      padding: '10px',
                      background: '#f0f9ff',
                      borderRadius: '6px',
                      border: '1px solid #bae6fd',
                    }}
                  >
                    <span
                      style={{
                        fontSize: '11px',
                        fontWeight: '600',
                        color: '#0369a1',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        display: 'block',
                        marginBottom: '6px',
                      }}
                    >
                      Selected Laboratory Investigations:
                    </span>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'flex-start' }}>
                      {values.laboratory.map((lab, index) => {
                        if (typeof lab === 'string') {
                          return (
                            <span
                              key={index}
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                padding: '4px 8px',
                                background: '#ffffff',
                                border: '1px solid #0891b2',
                                borderRadius: '4px',
                                fontSize: '11px',
                                color: '#0c4a6e',
                                fontWeight: '500',
                              }}
                            >
                              {lab}
                            </span>
                          );
                        }
                        return (
                          <div key={index} style={{ display: 'inline-flex', flexDirection: 'column', gap: '4px', maxWidth: '300px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
                              <span
                                style={{
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  color: '#0369a1',
                                }}
                              >
                                {lab?.category}
                              </span>
                              <span
                                style={{
                                  fontSize: '11px',
                                  color: '#6b7280',
                                  fontWeight: '500',
                                }}
                              >
                                ({lab?.name})
                              </span>
                            </div>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                              {lab?.options?.map((option, optIndex) => (
                                <span
                                  key={optIndex}
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    padding: '3px 8px',
                                    background: '#ffffff',
                                    border: '1px solid #0891b2',
                                    borderRadius: '4px',
                                    fontSize: '11px',
                                    color: '#0c4a6e',
                                    fontWeight: '500',
                                  }}
                                >
                                  {option}
                                </span>
                              ))}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}

              {/* Notes Section */}


              <Modal
                open={modal}
                closable={true}
                title={
                  <div style={{ padding: '10px 20px', borderBottom: '1px solid #f1f5f9' }}>
                    <Title level={4} style={{ margin: 0, fontWeight: 700, color: '#1e293b' }}>
                      Diagnostic Laboratory Investigations
                    </Title>
                  </div>
                }
                footer={null}
                forceRender={true}
                zIndex={1050}
                width={1000}
                style={{ top: 20 }}
                onOk={() => SetModal(false)}
                styles={{
                  mask: {
                    backdropFilter: 'blur(10px)',
                  },
                  header: {
                    margin: 0,
                    padding: 0
                  },
                  content: {
                    borderRadius: 24,
                    padding: 0,
                    overflow: 'hidden'
                  },
                  body: {
                    padding: 0
                  }
                }}
                centered
                confirmLoading={false}
                onCancel={() => SetModal(false)}
                closeIcon={
                  <div style={{
                    padding: '8px',
                    background: '#f1f5f9',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '10px',
                    marginRight: '10px',
                    transition: 'all 0.3s'
                  }}>
                    <FeatherIcon icon="x" size="18" style={{ color: '#64748b' }} />
                  </div>
                }
              >
                <div style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                  <LabInvestigationComponent
                    errors={errors}
                    touched={touched}
                    values={values}
                    name={'laboratory'}
                    laboratory={
                      (ConsultationMasterData?.laboratories && [
                        ConsultationMasterData?.laboratories,
                      ]) ||
                      []
                    }
                    setValues={setValues}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    disabled={IsFilledForm}
                  />
                </div>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LaboratoryInvestigations;